import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "54",
  viewBox: "0 0 56 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"27.5\" cy=\"27.5\" r=\"27.5\" fill=\"url(#paint0_linear_262_2570)\"></circle><ellipse cx=\"27.5002\" cy=\"27.5\" rx=\"24.3571\" ry=\"24.3571\" fill=\"#262626\"></ellipse><path d=\"M40 15H15V19.1667H40V15Z\" fill=\"white\"></path><path d=\"M32.8571 25.4173H15V29.584H32.8571V25.4173Z\" fill=\"white\"></path><path d=\"M25.7143 35.8332H15V39.9999H25.7143V35.8332Z\" fill=\"white\"></path>", 5)
const _hoisted_7 = {
  key: 0,
  cx: "44.75",
  cy: "43.212",
  rx: "11",
  ry: "10.8866",
  fill: "url(#paint1_linear_262_2570)"
}
const _hoisted_8 = {
  key: 1,
  x: "80%",
  y: "78%",
  "text-anchor": "middle",
  "alignment-baseline": "middle",
  fill: "white",
  "font-size": "15"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<defs><linearGradient id=\"paint0_linear_262_2570\" x1=\"27.5\" y1=\"0\" x2=\"27.5\" y2=\"55\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#60A5FA\"></stop><stop offset=\"1\" stop-color=\"#8B5DF1\"></stop></linearGradient><linearGradient id=\"paint1_linear_262_2570\" x1=\"44.75\" y1=\"32.3254\" x2=\"44.75\" y2=\"54.0986\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#60A5FA\"></stop><stop offset=\"1\" stop-color=\"#8B5DF1\"></stop></linearGradient></defs>", 1)

import { useFriendsStore } from "@/store/useFriendsStore";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftButtonMenu',
  setup(__props) {

const friendsStore = useFriendsStore();

const numberNotifications = computed(() => {
  return friendsStore.friendRequestsToMe.length;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    (numberNotifications.value > 0)
      ? (_openBlock(), _createElementBlock("ellipse", _hoisted_7))
      : _createCommentVNode("", true),
    (numberNotifications.value > 0)
      ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString(numberNotifications.value), 1))
      : _createCommentVNode("", true),
    _hoisted_9
  ]))
}
}

})